import { useCallback, useRef, useState } from "react";

function useReferenceState(initial, initialReference = []) {
	const stateRef = useRef(initialReference);
	const [state, setState] = useState(initial);

	const defaultCheckFn = (reference = []) => {
		const defaultRef = reference.some((element) => !element);
		return !defaultRef;
	};

	const updateState = useCallback((callbackFn = null) => {
		if (callbackFn) {
			const update = callbackFn(stateRef.current);
			setState(update);
			return;
		}

		const check = defaultCheckFn(stateRef.current);
		setState(check);
	}, []);

	return [state, setState, stateRef.current, updateState];
}

export { useReferenceState };
